@let blok = block();

<img [ngSrc]="blok.asset.filename" width="20" height="20" [attr.aria-hidden]="blok.isDecorative" [attr.alt]="blok.isDecorative ? '' : blok.asset.alt" class="mr-4 mt-0.5">
<span class="break-words mr-2" [ngClass]="{ 'font-bold': blok.fontBold, 'text-right': blok.alignTextRight }">{{ blok.text }}</span>
@for (icon of blok.infoIcon; track icon._uid) {
    <s1-cms-component [blok]="icon"/>
}
